/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { pxToEm, centerAbsolutely } from 'utils/styles/style_helpers';
import { url } from 'utils/urls';



/* ++++++++++ --------------- EXPORT --------------- ++++++++++ */
// PAGE : ADs : IN CONTENT PLACEMENT : STYLES
// utliizes utils and CSS-IN-JS (JS objects converted to CSS using a library)
export default theme => ({
    incontent: {
        animationName: 'fadeInRight',

        '& .visual': {
            '& .device': {
                backgroundImage: `url(${url.image.app}/mks/graphic-placement-incontent-with-rail-large.png)`,
                width: pxToEm(673),
                height: pxToEm(443),
                '& .embed-container': {
                    width: pxToEm(267),
                    top: pxToEm(154),
                    left: pxToEm(102),
                    '& .ads-group': {
                        animationName: 'jello',
                        animationDuration: '.7s',
                        animationFillMode: 'forwards',
                        animationDelay: '1.1s',
                        height: pxToEm(113),
                        position: 'relative'
                    },
                    '& .ad-left': {
                        width: pxToEm(132),
                        position: 'absolute',
                        left: 0,
                        height: '100%'
                    },
                    '& .ad-right': {
                        width: pxToEm(132),
                        position: 'absolute',
                        right: pxToEm(1),
                        height: '100%'
                    },
                    '& .toggle-container': {
                        extend: centerAbsolutely
                    },
                    '& .ad': {
                        '&.inline': {
                            height: pxToEm(113)
                        }
                    },
                    '& .embed': {
                        backgroundImage: `url(${url.image.app}/mks/graphic-embed-profiling-incontent.png)`,
                        height: pxToEm(155),
                        '& .embed-ads-group': {
                            extend: centerAbsolutely,
                            width: '100%',
                            height: pxToEm(112),
                            marginTop: pxToEm(3),
                            transition: 'background .2s linear 0s',
                            opacity: '0',
                            animationName: 'fadeIn',
                            animationDuration: '.3s',
                            animationFillMode: 'forwards',
                            animationDelay: '1.7s'
                        },
                    },
                }
            }
        }
    },
});